/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A company-scoped, user-defined status pipeline (e.g. Adjusting, Appraisal, Production). Each pipeline owns an ordered list of claim statuses.
 * @export
 * @interface ClaimPipeline
 */
export interface ClaimPipeline {
    /**
     * Unique pipeline ID
     * @type {number}
     * @memberof ClaimPipeline
     */
    readonly id: number;
    /**
     * ID of the company this pipeline belongs to
     * @type {number}
     * @memberof ClaimPipeline
     */
    companyId: number;
    /**
     * Pipeline name
     * @type {string}
     * @memberof ClaimPipeline
     */
    name: string;
    /**
     * Optional description of the pipeline
     * @type {string}
     * @memberof ClaimPipeline
     */
    description?: string | null;
    /**
     * Optional hex color code for pipeline display (e.g., "#3B82F6")
     * @type {string}
     * @memberof ClaimPipeline
     */
    color?: string | null;
    /**
     * Whether this is the seeded default pipeline created with the company
     * @type {boolean}
     * @memberof ClaimPipeline
     */
    isSystemDefault: boolean;
    /**
     * Whether this pipeline is active
     * @type {boolean}
     * @memberof ClaimPipeline
     */
    isActive: boolean;
    /**
     * Order in which pipelines should be displayed
     * @type {number}
     * @memberof ClaimPipeline
     */
    displayOrder: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPipeline
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPipeline
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the ClaimPipeline interface.
 */
export function instanceOfClaimPipeline(value: object): value is ClaimPipeline {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isSystemDefault' in value) || value['isSystemDefault'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimPipelineFromJSON(json: any): ClaimPipeline {
    return ClaimPipelineFromJSONTyped(json, false);
}

export function ClaimPipelineFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPipeline {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'color': json['color'] == null ? undefined : json['color'],
        'isSystemDefault': json['isSystemDefault'],
        'isActive': json['isActive'],
        'displayOrder': json['displayOrder'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimPipelineToJSON(json: any): ClaimPipeline {
    return ClaimPipelineToJSONTyped(json, false);
}

export function ClaimPipelineToJSONTyped(value?: Omit<ClaimPipeline, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'name': value['name'],
        'description': value['description'],
        'color': value['color'],
        'isSystemDefault': value['isSystemDefault'],
        'isActive': value['isActive'],
        'displayOrder': value['displayOrder'],
    };
}

